import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CreditRegisterSuccessAction,
  CreditRegisterSuccessViewModel,
} from '../credit-register-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-credit-register-success',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-credit-register-success.component.html',
  styleUrls: ['./modal-credit-register-success.component.scss'],
})
export class ModalCreditRegisterSuccessComponent {
  @Input() open = false;
  @Input() viewModel: CreditRegisterSuccessViewModel = {
    flowType: 'b3',
    title: 'Registro enviado para confirmação.',
    description: '',
    carbonCreditCode: '',
    sentDateLabel: '',
    statusLabel: 'Registro enviado',
    showNextSteps: false,
  };

  @Output() action = new EventEmitter<CreditRegisterSuccessAction>();

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onNewRegister(): void {
    this.action.emit('new-register');
  }

  onConsultRegister(): void {
    this.action.emit('consult');
  }
}
